import { encryptUserData } from './encrypt';
const DEEPLINK_SCHEME = process.env.REACT_APP_DEEPLINK_SCHEME;
const DEEPLINK_LOGIN_SUCCESS = process.env.REACT_APP_DEEPLINK_LOGIN_SUCCESS;

/**
 * Determines if we are running in the context of the Red Bull TV app
 * @param applicationConfig
 * @returns {boolean}
 */
const isRedBullTVApp = (applicationConfig) => {
  return applicationConfig?.url === DEEPLINK_SCHEME;
};

/**
 * Determines if we are running in the context of any mobile app
 * If the url to redirect to does not contain http we can assume it's a deeplink to a mobile app
 * @param applicationConfig
 * @returns {boolean}
 */
const isMobileApp = (applicationConfig) => {
  return applicationConfig?.url?.indexOf('http') === -1;
};

const createUimRedirectParams = async (uim) => {
  const info = await uim.getUimClientInfo();
  return `uid=${info.uid}&access_token=${info.access_token}&refresh_token=${info.refresh_token}&id_token=${info.id_token}`;
};

const createMobileDeeplink = async (uim, encryptionKey, scheme) => {
  const deeplinkScheme = scheme || DEEPLINK_SCHEME;
  let params = '';

  if (encryptionKey) {
    const uimClientInfo = await uim.getUimClientInfo();
    const paramString = await encryptUserData(encryptionKey, uimClientInfo);
    params = `rbUser=${paramString}`;
  } else {
    params = await createUimRedirectParams(uim);
  }

  return `${deeplinkScheme}${DEEPLINK_LOGIN_SUCCESS}?${params}`;
};

export {
  createUimRedirectParams,
  createMobileDeeplink,
  isRedBullTVApp,
  isMobileApp,
};
